/* Arjit4Amply: Shop page filter tabs (All / Individual essentials /
   Bundle & Save), ported from the live reference's own real interaction
   (matre-earthy-2.vercel.app/?page=shop) - toggles [hidden] on cards by
   data-shop-kind, updates aria-pressed on the tabs, and keeps the live
   product count in sync. This is a pure display filter over whichever
   cards the section actually rendered (visibility toggles in
   sections/matre-shop.liquid already decide which cards exist in the DOM
   at all - this only filters among those). */
(function () {
  document.querySelectorAll('.matre-shop').forEach(initShop);

  function initShop(root) {
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-shop-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-shop-kind]'));
    var countEl = root.querySelector('[data-shop-count]');

    function applyFilter(kind) {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var matches = kind === 'all' || card.dataset.shopKind === kind;
        card.hidden = !matches;
        if (matches) visibleCount++;
      });
      if (countEl) countEl.textContent = visibleCount + ' products';
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b === button));
        });
        applyFilter(button.dataset.shopFilter);
      });
    });
  }
})();
